"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: black;\n  height: 216px;\n  width: 224px;\n  margin-right: 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Item = _styledComponents.default.div(_templateObject());

var Image = _styledComponents.default.img(_templateObject2());

var CarouselItem = function CarouselItem(_ref) {
  var src = _ref.src,
      onItemClick = _ref.onItemClick;
  return _react.default.createElement(Item, {
    onClick: onItemClick
  }, _react.default.createElement(Image, {
    src: src,
    alt: src
  }));
};

CarouselItem.defaultProps = {
  src: '',
  onItemClick: function onItemClick() {}
};
var _default = CarouselItem;
exports.default = _default;